<template>
  <div>
    <mt-header title="购买记录">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>
    <div style="height: 1rem;background-color: #ECECEC;"></div>
    <div v-show="isNotExist" class="mycb notExist">
      <img src="/static/img/combo/comboGrey.png"/>
      <div><span>空空的~~,请去购买套餐吧</span></div>
    </div>
    <div v-show="!isNotExist">
      <ul>
        <li v-for="item in itemsCCIVO2" :key='item.orderNO'>
          <div class="comboRecord-view-list">
            <div class="comboRecorditem">
              <div class="comboPayMode"><span>{{item.comboName}}</span></div>
              <div class="comboNum"><span>￥{{item.price}}</span>
                <span v-if="item.paidMode != '2'" class="comboRecord-totalNum-span">/{{item.number}}次</span>
              </div>
            </div>
            <div class="comboRecorditemmid">
              <div class="comboRecordDate"><span>订单时间:{{item.orderTime | formatDate}}</span></div>
              <div class="comboNum">
                <span v-show="item.status==0" @click="gotoBuyCombo(item.orderNo,item.id)" class="comboRecord-totalNum-span-notpay">{{item.status | comboRecordformat}}</span>
                <span v-show="item.status!=0" class="comboRecord-totalNum-span">{{item.status | comboRecordformat}}</span>
              </div>
            </div>
            <div v-show="validatePaidMode(item.paidMode)">
              <div class="comboRecordDate"><span>有效期截止时间:{{item.endTime}}</span></div>
            </div>

            <hr style="margin-top: 1.5rem">
          </div>
        </li>
      </ul>

    </div>

    <div id="payId">
    </div>
  </div>
</template>
<script>
  import {Toast, Indicator} from 'mint-ui';
  export default {
    data () {
      return {
        isNotExist: true,
        itemsCCIVO2: '',
        comboName: '个人套餐',
        comboDate: "2017-01-02",
        num: 10,
        payStatus: ''
      }
    },
    methods: {
      validatePaidMode(paidMode){
        if (paidMode == '2' || paidMode == '3') {
          return true;
        } else {
          return false;
        }
      },
      gotoBuyCombo(orderNo,id) {
       this.$router.push({
         path: "/combo/payOldOrder",
         query:{
           orderNo:orderNo,
           id:id
         }
       })
      },
      goBack: function () {
        this.$router.push({
          path: "/combo/mycombo",
          name: 'mycombo'
        })
      },
      payOrderSync(orderNO){
        var payOrderSyncURL = domain("_payOrderSync");
        var that = this;
        that.$http.post(
          payOrderSyncURL,
          {orderNO:orderNO},
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据

          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      fetcchcrMsg(){
        var _myComborecord_url = domain("_myComborecord");
        var that = this;
        that.$http.post(
          _myComborecord_url,
          {},
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
          console.log(response);
            that.itemsCCIVO2 = response.body.data.list;
            if (that.itemsCCIVO2.length != 0) {
              that.isNotExist = false;
              //var orderNO =this.itemsCCIVO2[0].orderNO;
              //this.payOrderSync(orderNO);
            }

          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      }
    },
    filters: {
      comboRecordformat(status){
        if (status == '0') {
          return '去支付';
        } else if (status == '1') {
          return '已支付';
        } else if (status == '2') {
          return '取消';
        }
      },
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    mounted: function () {
      this.fetcchcrMsg();
    }
  }
</script>
<style>
  #comboRecord {
    background-color: #FFFFFF;
    width: 100%;
    min-height: 100%;
  }

  .comboPayMode {
    display: inline;
    padding-left: 20px;
    color:#7d7d7d;
    font-size: 1rem;
  }

  .comboNum {
    float: right;
    padding-right: 0.5rem;
  }

  .comboRecordDate {
    display: inline;
    padding-left: 20px;
    color:#7d7d7d;
    font-size: 0.8rem;
  }

  .mycb {
    margin-left: 4%;
    margin-right: 4%;
    background-color: #ffffff;
    margin-top: 1.5rem;
    font-size: 1rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
    border-radius: 5px;
  }

  .notExist {
    text-align: center;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .notExist img {
    width: 40px;
  }

  .comboRecord-totalNum-span{
    color: #c1c1c1;
    padding: 0.2rem;
  }

  .comboRecord-totalNum-span-notpay{
    color: #f09536;
    padding: 0.2rem;
    font-size: 1rem;
  }
  .comboRecorditem{
    padding-top: 20px;
  }
  .comboRecorditemmid{
    margin-top:5px;
  }
</style>



// WEBPACK FOOTER //
// src/module/combo/ComboRecord.vue